module.exports = __webpack_public_path__ + "img/ennetix-overview-application-traffic.aa2bbad4.png";